
export function crmSyncConversation() {
  return {
    restrict: 'E',
    template: require('./crm-sync-conversation.html'),
    scope: {
      company: '<',
      organizationId: '<',
      organizationType: '<',
      configuration: '=',
      freshData: '<',
      isAlcmeonUser: '<'
    },
    controller: controller,
  };
}

controller.$inject = ['$scope', 'DropdownItemsFactory', '$translate'];
function controller($scope, DropdownItemsFactory, $translate) {

  $scope.blinkWorkflowTitle = blinkWorkflowTitle;
  $scope.workflowMappingFromAlcmeonToSalesforceChanged = workflowMappingFromAlcmeonToSalesforceChanged;
  $scope.workflowMappingFromSalesforceToAlcmeonChanged = workflowMappingFromSalesforceToAlcmeonChanged;

  $scope.triggerMsgRoutedToCrmTeam = {
    msg_replied_by_agent_and_user_matched: 0,
    msg_routed_to_crm_team: 1,
  };
  $scope.triggerMsgRepliedByAgentAndUserMatched = {
    msg_replied_by_agent_and_user_matched: 1,
    msg_routed_to_crm_team: 0,
  };

  init();

  function workflowMappingFromAlcmeonToSalesforceChanged($event) {
    $scope.configuration.workflow_mappings.from_alcmeon_to_sf = $event || [];
  }

  function workflowMappingFromSalesforceToAlcmeonChanged($event) {
    $scope.configuration.workflow_mappings.from_sf_to_alcmeon = $event || [];
  }

  function initSalesforceConfiguration() {
    if (!$scope.configuration) {
      $scope.configuration = {
        agents_workflow: {
          from_alcmeon: {
            enabled: 0,
            push_to_crm_triggers: {
              msg_routed_to_crm_team: 0,
              msg_replied_by_agent_and_user_matched: 0
            }
          },
          from_sf: {
            enabled: 0
          }
        },
        workflow_mappings: {
          from_alcmeon_to_sf: [],
          from_sf_to_alcmeon: [],
        },
        sync_mode: {
          mode: $scope.syncFrequence
        }
      }
    }
    const fromAlcmeonConfig = $scope.configuration.agents_workflow.from_alcmeon;

    if (fromAlcmeonConfig.push_to_crm_triggers.msg_routed_to_crm_team) {
      fromAlcmeonConfig.push_to_crm_triggers = $scope.triggerMsgRoutedToCrmTeam;
    } else {
      fromAlcmeonConfig.push_to_crm_triggers = $scope.triggerMsgRepliedByAgentAndUserMatched;
    }
  }

  function initZendeskConfiguration() {

    if (!$scope.configuration || !$scope.configuration.sync_mode) {
      $scope.configuration = {
        sync_mode: {
          continous_synchronization_enabled: false,
          mode: 'synchronous'
        }
      }
    }
    if (!$scope.configuration.agents_workflow) {
      $scope.configuration.agents_workflow = {
        from_alcmeon: {
          enabled: true,
          push_to_crm_triggers: $scope.triggerMsgRepliedByAgentAndUserMatched
        },
        from_sf: {
          enabled: false,
          routing_user_custom_field_ids: []
        }
      };
    }

    if (!$scope.configuration.workflow_mappings) {
      $scope.configuration.workflow_mappings = {
        from_alcmeon_to_sf: [],
        from_sf_to_alcmeon: []
      }
    }
  }

  function initConversationSyncFrequencies() {
    $scope.conversationSyncFrequencies = [
      {
        title: $translate.instant('crm/configuration/sync-conversation-frequencies/real-time-title'),
        description: $translate.instant('crm/configuration/sync-conversation-frequencies/real-time-description'),
        id: "synchronous"
      },
      {
        title: $translate.instant('crm/configuration/sync-conversation-frequencies/periodic-title'),
        description: $translate.instant('crm/configuration/sync-conversation-frequencies/periodic-description'),
        id: "periodic",
        disabled: true
      }
    ]
    $scope.syncFrequence = $scope.conversationSyncFrequencies[0];
  }


  function blinkWorkflowTitle(workflowType) {
    const elementId = workflowType === 'sfToAlcmeon' ? 'crm-to-alcmeon-workflow' : 'alcmeon-to-crm-workflow';
    const workflowMappingTitle = document.getElementById(elementId);
    workflowMappingTitle.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => workflowMappingTitle.classList.add('alc-blink-workflow'), 500);
    setTimeout(() => workflowMappingTitle.classList.remove('alc-blink-workflow'), 2000);
  }

  function init() {
    initConversationSyncFrequencies();

    if ($scope.organizationType === 'salesforce') {
      initSalesforceConfiguration();
      let routingTags = $scope.company.tags_groups.filter(
        (tag_group) => tag_group.is_routing === 1
      );
      $scope.routingTagsItems = DropdownItemsFactory.buildTagItems(
        routingTags
      )[0].items.flatMap((i) => i.subitems);

      $scope.availableSfQueues = $scope.freshData.available_queues.map((aq) => {
        return {
          id: aq.Id,
          label: aq.Name,
        };
      });
    } else if ($scope.organizationType === 'zendesk') {
      initZendeskConfiguration();
    }
  }
}